<template>
  <BasePage title="Login" >
      <AuthContainer>
      <section class="mt-4 box">
        <h1 class="title is-2">Login</h1>

        <form action="" method="post" @submit.prevent="login()">
          <div class="field">
            <label class="label">Email</label>
            <p class="control">
              <input
                v-focus
                v-model="email"
                :class=" error && 'is-danger'"
                class="input"
                type="email"
                placeholder="name@example.com"
                required
                />
            </p>
          </div>

          <div class="field">
            <label class="label">Password</label>
            <p class="control">
              <input
                :class=" error && 'is-danger'"
                v-model="password"
                class="input"
                type="password"
                placeholder="super secret password"
                required
                />
            </p>

          <p class="text-danger" v-if="error">{{ errorMessage }}</p>

          </div>
          <div class="field">
            <p class="control flex-space-between flex-align-center">
              <button :class="{ 'is-loading': loading }" class="button is-primary">Login</button>
              <router-link to='/forgot-password' >Forgot password?</router-link>
            </p>
          </div>

        </form>

        <div class="d-flex align-items-center mb-2 mt-1">
          <span class="or-bar"></span> or <span class="or-bar"></span>
        </div>
        <SocialButtons :page="'login'" :loading="loading"/>

        <p class="mt-4">
          Need an account? <router-link class="" to="/signup">Signup →</router-link>
        </p>

      </section>

    </AuthContainer>
  </BasePage>
</template>

<script>
import AuthContainer from './AuthContainer'
import BasePage from './BasePage.vue'
import { focus } from '../directives.js'
import SocialButtons from './SocialButtons'

import {
  login,
} from '../actionTypes'

import {
  setLoginErrorMessage
} from '../mutationTypes'

import store from '../store'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      loading: false,
    }
  },
  components: {
    BasePage,
    SocialButtons,
    AuthContainer,
  },
  mounted () {
    store.commit(setLoginErrorMessage, '')
  },
  methods: {
    async login () {
      const { email, password } = this
      this.loading = true
      await store.dispatch(login, { email, password })
      this.loading = false
    },
  },
  computed: {
    error () {
      return store.state.loginErrorMessage !== ''
    },
    errorMessage () {
      return store.state.loginErrorMessage
    },
  },
  directives: {
    focus,
  },
}
</script>

<style lang="scss" scoped>

@import '../_variables.scss';

.box {
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.4);
  border-radius: 5px;
}

.container {
    margin: initial;
}

.title {
  margin-bottom: 0.5rem !important;
}

.title-subtext {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// Login.vue?002a2d0a